import { render, staticRenderFns } from "./formQtwj.vue?vue&type=template&id=57484d35&scoped=true&"
import script from "./formQtwj.vue?vue&type=script&lang=js&"
export * from "./formQtwj.vue?vue&type=script&lang=js&"
import style0 from "./formQtwj.vue?vue&type=style&index=0&id=57484d35&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57484d35",
  null
  
)

export default component.exports